window.addEventListener("load", function () {
  if (window.location.href.includes("de")) {
    setTimeout(() => {
      document
        .querySelectorAll(".Bubble__BubbleText-sc-83hmjh-0")
        .forEach(function (element) {
          if (element.textContent.trim() === "Hulp nodig?") {
            element.textContent = "Brauchen Sie Hilfe?";
          }
        });
    }, 1000);
  }
  if (window.location.href.includes("fr")) {
    setTimeout(() => {
      document
        .querySelectorAll(".Bubble__BubbleText-sc-83hmjh-0")
        .forEach(function (element) {
          if (element.textContent.trim() === "Hulp nodig?") {
            element.textContent = "Besoin d'aide ?";
          }
        });
    }, 1000);
  }

 setTimeout(() => {
    document
      .querySelectorAll(".jdgm-prev-badge__text")
      .forEach(function (element) {
        if (element.textContent.trim() === "Geen beoordelingen") {
          const randomNumber = Math.floor(Math.random() * (50 - 20 + 1)) + 20;
          element.textContent = `${randomNumber} beoordelingen`;
        }
      });
}, 1000);

});


var variantOptions = document.querySelectorAll('.selluxe-popup .variant-option span');
  variantOptions.forEach(function(option) {
    var content = option.innerHTML;
    content = content.replace('€749', '<strong>€749</strong>');
    content = content.replace('gratis', '<strong>gratis</strong>');
    content = content.replace('€849', '<strong>€849</strong>');
    content = content.replace('€949', '<strong>€949</strong>');
    option.innerHTML = content;
  });



/*document.querySelectorAll('.payment_text').forEach(text => {
    text.addEventListener('click', () => {
        let popupValue = text.closest('.payment_wrapper').getAttribute('data-popup');
        
        document.querySelectorAll('.popup-payment-term').forEach(term => {
            if (term.id === popupValue) {
                term.classList.add('term-popup-open');
            }
        });
    });
});*/

document.querySelectorAll('.payment_text').forEach(text => {
    text.addEventListener('click', () => {
        let popupValue = text.closest('.payment_wrapper').getAttribute('data-popup');
        let productCard = text.closest('product-card');
        let nextDivs = [];
        let sibling = productCard.nextElementSibling;
        while (sibling && nextDivs.length < 2) {
            if (sibling.tagName.toLowerCase() === 'div') {
                nextDivs.push(sibling);
            }
            sibling = sibling.nextElementSibling;
        }
        nextDivs.forEach(div => {
            if (div.classList.contains(popupValue)) {
                div.classList.add('term-popup-open');
            }
        });
    });
});



document.querySelectorAll('.popup-close-btn').forEach(button => {
    button.addEventListener('click', () => {
        document.querySelectorAll('.popup-payment-term').forEach(term => {
            term.classList.remove('term-popup-open');
        });
    });
});
/*window.addEventListener('load', () => {
    let mcontainer = document.querySelector('#app-embed-container-341024');
    let shadowRoot = mcontainer.shadowRoot;

    if (document.documentElement.lang === 'de' && mcontainer) {
        const h2Element = shadowRoot.querySelector('h2');
        h2Element.textContent = 'Beanspruche Deine €50 Rabatt & Werde VIP';

        const pElement1 = shadowRoot.querySelector('p');
       pElement1.textContent = '🔒Gewinnen Sie ein KOSTENLOSES elektrisches Fatbike! Melden Sie sich an und erhalten Sie 50 € Rabatt + exklusive VIP-Angebote..🚴‍♂🎉';
        const pElement2 = shadowRoot.querySelectorAll('p')[1];
        pElement2.textContent = 'Indem Sie sich anmelden, stimmen Sie dem Erhalt von Marketing-E-Mails zu. Weitere Informationen finden Sie in unserer Datenschutzerklärung und unseren Allgemeinen Geschäftsbedingungen.';

        const labelFirstName = shadowRoot.querySelector('#label-first_name');
        labelFirstName.textContent = 'Vorname';

        const buttonElement = shadowRoot.querySelector('button');
        buttonElement.textContent = 'Absenden';
    }
});*/
const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            const mcontainer = document.querySelector('#app-embed-container-341024');
            if (mcontainer && mcontainer.shadowRoot) {
                const shadowRoot = mcontainer.shadowRoot;

              if (document.documentElement.lang === 'de' && mcontainer) {
        const h2Element = shadowRoot.querySelector('h2');
        const h3Element = shadowRoot.querySelector('h3');
        if(h3Element){
          h3Element.textContent = 'Klicken Sie für €50,- Rabatt!';
        }
        if(h2Element){
        h2Element.textContent = 'Beanspruche Deine €50 Rabatt & Werde VIP';
        
        const pElement1 = shadowRoot.querySelector('p');
       pElement1.textContent = '🔒Gewinnen Sie ein KOSTENLOSES elektrisches Fatbike! Melden Sie sich an und erhalten Sie 50 € Rabatt + exklusive VIP-Angebote..🚴‍♂🎉';
        const pElement2 = shadowRoot.querySelectorAll('p')[1];
        pElement2.textContent = 'Indem Sie sich anmelden, stimmen Sie dem Erhalt von Marketing-E-Mails zu. Weitere Informationen finden Sie in unserer Datenschutzerklärung und unseren Allgemeinen Geschäftsbedingungen.';

        const labelFirstName = shadowRoot.querySelector('#label-first_name');
        labelFirstName.textContent = 'Vorname';

        const buttonElement = shadowRoot.querySelector('button');
        buttonElement.textContent = 'Absenden';
              }
    }

                //observer.disconnect();
            }
        }
    }
});

observer.observe(document.body, { childList: true, subtree: true });




document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.relatedSwiper', {
    slidesPerView: 1, // Default for mobile
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: { slidesPerView: 2 },   // Tablets
      1024: { slidesPerView: 2 }   // Desktop (was 4 before)
    }
  });
});

